// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2SFuV","requiredAsterisk":"Info_requiredAsterisk__2cNLU"};